(function () {
  var SHOWN_KEY = 'exit_popup_shown';
  var TIMER_KEY = 'promo_timer_end';
  var triggered = false;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function getRemainingTime() {
    var endTime = parseInt(sessionStorage.getItem(TIMER_KEY), 10);
    if (!endTime) return '20:00';
    var remaining = Math.max(0, endTime - Date.now());
    var totalSecs = Math.floor(remaining / 1000);
    return pad(Math.floor(totalSecs / 60)) + ':' + pad(totalSecs % 60);
  }

  function buildPopup() {
    var overlay = document.createElement('div');
    overlay.className = 'exit-popup-overlay';
    overlay.id = 'exit-popup-overlay';

    var productUrl = document.querySelector('a[href*="/products/"]');
    var ctaHref = productUrl ? productUrl.getAttribute('href') : '/';

    overlay.innerHTML =
      '<div class="exit-popup" role="dialog" aria-modal="true" aria-label="Oferta especial">' +
        '<button class="exit-popup__close" aria-label="Cerrar">✕</button>' +
        '<div class="exit-popup__header">' +
          '<span class="exit-popup__emoji">⏳</span>' +
          '<div class="exit-popup__title">¡Espera! Tu precio especial vence pronto</div>' +
          '<div class="exit-popup__subtitle">No pierdas esta oferta exclusiva de hoy</div>' +
        '</div>' +
        '<div class="exit-popup__body">' +
          '<div class="exit-popup__timer-row">' +
            '<span class="exit-popup__timer-label">Tu oferta vence en:</span>' +
            '<span class="exit-popup__timer" id="exit-popup-countdown">' + getRemainingTime() + '</span>' +
          '</div>' +
          '<a href="' + ctaHref + '" class="exit-popup__cta">🛒 Ordenar ahora al precio especial</a>' +
          '<button class="exit-popup__dismiss">No, prefiero pagar precio normal</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('exit-popup--visible');
      });
    });

    // Sync timer
    var timerEl = document.getElementById('exit-popup-countdown');
    if (timerEl) {
      setInterval(function () {
        timerEl.textContent = getRemainingTime();
      }, 1000);
    }

    function close() {
      overlay.classList.remove('exit-popup--visible');
      setTimeout(function () { if (overlay.parentNode) overlay.remove(); }, 400);
    }

    overlay.querySelector('.exit-popup__close').addEventListener('click', close);
    overlay.querySelector('.exit-popup__dismiss').addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
  }

  function trigger() {
    if (triggered) return;
    if (sessionStorage.getItem(SHOWN_KEY)) return;
    triggered = true;
    sessionStorage.setItem(SHOWN_KEY, '1');
    buildPopup();
  }

  function init() {
    // Desktop: mouse leaves toward top of page
    document.documentElement.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 5) trigger();
    });

    // Mobile: inactivity after 40s
    var mobileTimer;
    var resetTimer = function () {
      clearTimeout(mobileTimer);
      mobileTimer = setTimeout(trigger, 40000);
    };
    ['touchstart', 'touchmove', 'scroll'].forEach(function (evt) {
      document.addEventListener(evt, resetTimer, { passive: true });
    });
    resetTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
